module.exports = __webpack_public_path__ + "static/media-baseline-707b34e9d4f5929a9b1d78a06fddeaf1.jpg";